import { render, staticRenderFns } from "./CoFile.vue?vue&type=template&id=5c77aa04&scoped=true&"
import script from "./CoFile.vue?vue&type=script&lang=ts&"
export * from "./CoFile.vue?vue&type=script&lang=ts&"
import style0 from "./CoFile.vue?vue&type=style&index=0&id=5c77aa04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c77aa04",
  null
  
)

export default component.exports